module.exports = __webpack_public_path__ + "img/ic-facebook-logotype.4ce78fe3.svg";